// Theme: nebula-iridium
// Auto-generated by scripts/materialize-theme-presets.ts
// Source of truth for theme configuration

import type { ThemePreset } from '@/lib/themes/types'

export const THEME_PRESET: ThemePreset = {
  id: 'nebula-iridium',
  name: 'NEBULA IRIDIUM',
  tagline: 'NEBULA IRIDIUM',
  description: 'Nebulosa em iridescencia azul. Mesma estrutura Nebula, paleta fria.',
  category: 'cosmic-scale',
  tier: 'epic',
  basePrice: 3675,
  swatches: ['#11162A', '#8CB3FF', '#1E2A4A', '#DDEBFF'],
  familyId: 'nebula',
  variantName: 'IRIDIUM',
  baseStyle: {
    cardClasses: '',
    shapeVars: {
      '--border-w': '1px',
      '--radius': '12px',
      '--shadow-card': '0 14px 36px rgba(140, 179, 255, 0.10)',
      '--shadow-card-active': '0 16px 42px rgba(140, 179, 255, 0.10)'
    },
    shellClasses: 'font-sans theme-nebula-iridium'
  },
  colorVars: {
    '--accent': '#8CB3FF',
    '--accent-foreground': '#11162A',
    '--background': '#11162A',
    '--border': '#3D5A9A',
    '--card': '#1E2A4A',
    '--card-border-active': 'rgba(140, 179, 255, 0.10)',
    '--card-completed': '#26375E',
    '--card-foreground': '#DDEBFF',
    '--card-glow': 'rgba(140, 179, 255, 0.10)',
    '--coin': 'var(--rarity-legendary)',
    '--destructive': '#ef4444',
    '--destructive-foreground': '#11162A',
    '--foreground': '#DDEBFF',
    '--hold-fill': '#8CB3FF',
    '--input': '#1E2A4A',
    '--modal-bg': '#11162A',
    '--modal-border': '#3D5A9A',
    '--modal-overlay-bg': 'rgba(0, 0, 0, 0.75)',
    '--modal-shadow': '0 14px 36px rgba(140, 179, 255, 0.10)',
    '--muted': '#3D5A9A',
    '--muted-foreground': '#A8C2EE',
    '--nav-active': '#8CB3FF',
    '--nav-bg': '#11162A',
    '--popover': '#1E2A4A',
    '--popover-foreground': '#DDEBFF',
    '--primary': '#8CB3FF',
    '--primary-foreground': '#11162A',
    '--ring': '#8CB3FF',
    '--secondary': '#3D5A9A',
    '--secondary-foreground': '#DDEBFF',
    '--streak': '#8CB3FF',
    '--success': '#22c55e',
    '--success-foreground': '#11162A',
    '--xp': '#8CB3FF',
    '--xp-bg': '#1E2A4A'
  },
  resolvedVars: {
    '--accent': '#8CB3FF',
    '--accent-foreground': '#11162A',
    '--accent-foreground-hsl': '228 42% 12%',
    '--accent-foreground-oklch': 'from #11162A l c h',
    '--accent-hsl': '220 100% 77%',
    '--accent-oklch': 'from #8CB3FF l c h',
    '--background': '#11162A',
    '--background-hsl': '228 42% 12%',
    '--background-oklch': 'from #11162A l c h',
    '--border': '#3D5A9A',
    '--border-hsl': '221 43% 42%',
    '--border-oklch': 'from #3D5A9A l c h',
    '--border-w': '1px',
    '--card': '#1E2A4A',
    '--card-border-active': 'rgba(140, 179, 255, 0.10)',
    '--card-completed': '#26375E',
    '--card-completed-hsl': '222 42% 26%',
    '--card-completed-oklch': 'from #26375E l c h',
    '--card-foreground': '#DDEBFF',
    '--card-foreground-hsl': '215 100% 93%',
    '--card-foreground-oklch': 'from #DDEBFF l c h',
    '--card-glow': 'rgba(140, 179, 255, 0.10)',
    '--card-hsl': '224 42% 20%',
    '--card-oklch': 'from #1E2A4A l c h',
    '--coin': 'var(--rarity-legendary)',
    '--destructive': '#ef4444',
    '--destructive-foreground': '#11162A',
    '--destructive-foreground-hsl': '228 42% 12%',
    '--destructive-foreground-oklch': 'from #11162A l c h',
    '--destructive-hsl': '0 84% 60%',
    '--destructive-oklch': 'from #ef4444 l c h',
    '--foreground': '#DDEBFF',
    '--foreground-hsl': '215 100% 93%',
    '--foreground-oklch': 'from #DDEBFF l c h',
    '--hold-fill': '#8CB3FF',
    '--hold-fill-hsl': '220 100% 77%',
    '--hold-fill-oklch': 'from #8CB3FF l c h',
    '--input': '#1E2A4A',
    '--input-hsl': '224 42% 20%',
    '--input-oklch': 'from #1E2A4A l c h',
    '--modal-bg': '#11162A',
    '--modal-bg-hsl': '228 42% 12%',
    '--modal-bg-oklch': 'from #11162A l c h',
    '--modal-border': '#3D5A9A',
    '--modal-border-hsl': '221 43% 42%',
    '--modal-border-oklch': 'from #3D5A9A l c h',
    '--modal-overlay-bg': 'rgba(0, 0, 0, 0.75)',
    '--modal-shadow': '0 14px 36px rgba(140, 179, 255, 0.10)',
    '--muted': '#3D5A9A',
    '--muted-foreground': '#A8C2EE',
    '--muted-foreground-hsl': '218 67% 80%',
    '--muted-foreground-oklch': 'from #A8C2EE l c h',
    '--muted-hsl': '221 43% 42%',
    '--muted-oklch': 'from #3D5A9A l c h',
    '--nav-active': '#8CB3FF',
    '--nav-active-hsl': '220 100% 77%',
    '--nav-active-oklch': 'from #8CB3FF l c h',
    '--nav-bg': '#11162A',
    '--nav-bg-hsl': '228 42% 12%',
    '--nav-bg-oklch': 'from #11162A l c h',
    '--popover': '#1E2A4A',
    '--popover-foreground': '#DDEBFF',
    '--popover-foreground-hsl': '215 100% 93%',
    '--popover-foreground-oklch': 'from #DDEBFF l c h',
    '--popover-hsl': '224 42% 20%',
    '--popover-oklch': 'from #1E2A4A l c h',
    '--primary': '#8CB3FF',
    '--primary-foreground': '#11162A',
    '--primary-foreground-hsl': '228 42% 12%',
    '--primary-foreground-oklch': 'from #11162A l c h',
    '--primary-hsl': '220 100% 77%',
    '--primary-oklch': 'from #8CB3FF l c h',
    '--radius': '12px',
    '--ring': '#8CB3FF',
    '--ring-hsl': '220 100% 77%',
    '--ring-oklch': 'from #8CB3FF l c h',
    '--secondary': '#3D5A9A',
    '--secondary-foreground': '#DDEBFF',
    '--secondary-foreground-hsl': '215 100% 93%',
    '--secondary-foreground-oklch': 'from #DDEBFF l c h',
    '--secondary-hsl': '221 43% 42%',
    '--secondary-oklch': 'from #3D5A9A l c h',
    '--shadow-card': '0 14px 36px rgba(140, 179, 255, 0.10)',
    '--shadow-card-active': '0 16px 42px rgba(140, 179, 255, 0.10)',
    '--streak': '#8CB3FF',
    '--streak-hsl': '220 100% 77%',
    '--streak-oklch': 'from #8CB3FF l c h',
    '--success': '#22c55e',
    '--success-foreground': '#11162A',
    '--success-foreground-hsl': '228 42% 12%',
    '--success-foreground-oklch': 'from #11162A l c h',
    '--success-hsl': '142 71% 45%',
    '--success-oklch': 'from #22c55e l c h',
    '--tint-primary-subtle': 'hsla(220 100% 77% / 0.15)',
    '--xp': '#8CB3FF',
    '--xp-bg': '#1E2A4A',
    '--xp-bg-hsl': '224 42% 20%',
    '--xp-bg-oklch': 'from #1E2A4A l c h',
    '--xp-hsl': '220 100% 77%',
    '--xp-oklch': 'from #8CB3FF l c h'
  }
}
